// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Gorgias Integration Styles */
.BC-Page.BC-Page__GorgiasIntegration .gorgias-container .gorgias-group-row {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.BC-Page.BC-Page__GorgiasIntegration .gorgias-container .gorgias-row {
  display: flex;
  gap: 20px;
}

.BC-Page.BC-Page__GorgiasIntegration .gorgias-container .gorgias-col-content {
  width: 612px;
  flex-shrink: 0;
}

.BC-Page.BC-Page__GorgiasIntegration .gorgias-container .Polaris-Card {
  height: 100%;
}

.BC-Page.BC-Page__GorgiasIntegration .gorgias-container .Polaris-Card .card-inner {
  padding: 16px;
  height: 100%;
}

.BC-Page.BC-Page__GorgiasIntegration .gorgias-container .Polaris-Card .card-inner.card-inner--column {
  display: flex;
  flex-direction: column;
}

.BC-Page.BC-Page__GorgiasIntegration .gorgias-container .Polaris-Card .card-inner .BC-Switch-Status {
  height: 16px;
  width: 34px;
  margin-right: 8px;
  display: inline-flex;
}

.BC-Page.BC-Page__GorgiasIntegration .gorgias-container .Polaris-Card .card-inner .BC-Switch-Status__Bar {
  width: 34px;
  height: 16px;
}

.BC-Page.BC-Page__GorgiasIntegration .gorgias-container .Polaris-Card .card-inner .BC-Switch-Status__Dot {
  width: 16px;
  height: 16px;
  transform: translateX(0);
}

.BC-Page.BC-Page__GorgiasIntegration .BC-Switch-Status input:checked+.BC-Switch-Status__Bar .BC-Switch-Status__Dot {
  -webkit-transform: translateX(16px);
  -ms-transform: translateX(16px);
  transform: translateX(16px);
}

.BC-Page.BC-Page__GorgiasIntegration .BC-Page__Title--Help {
  padding-left: 53px;
}

.BC-Page.BC-Page__GorgiasIntegration .gorgias-container .divider {
  border: 1px solid #E1E3E5;
  margin-bottom: 24px;
}

/* Style settings card */
.BC-Page.BC-Page__GorgiasIntegration .gorgias-style-settings {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.BC-Page.BC-Page__GorgiasIntegration .gorgias-style-settings__preview-description {
  margin-top: 2px;
  margin-bottom: 16px;
  color: #637381;
  font-size: 14px;
}

.BC-Page.BC-Page__GorgiasIntegration .gorgias-style-settings__preview-box {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 70px;
  padding: 16px 24px;
  border: 1px dashed #c9cccf;
  border-radius: 6px;
}

.BC-Page.BC-Page__GorgiasIntegration .gorgias-style-settings__container {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Button preview */
.BC-Page.BC-Page__GorgiasIntegration .gorgias-button-preview__container {
  display: inline-block;
}

/* Error message with icon */
.BC-Page.BC-Page__GorgiasIntegration .gorgias-btn-text__container .gorgias-btn-text__label {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}

.BC-Page.BC-Page__GorgiasIntegration .gorgias-btn-text__container .Polaris-Labelled__HelpText {
  text-align: right;
}

.BC-Page.BC-Page__GorgiasIntegration .gorgias-btn-text__container .Polaris-InlineError {
  margin-top: 0;
}

.BC-Page.BC-Page__GorgiasIntegration .gorgias-error-message {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.BC-Page.BC-Page__GorgiasIntegration .gorgias-error-message .Polaris-Icon {
  width: 16px;
  height: 16px;
}

/* Feedback link */
.BC-Page.BC-Page__GorgiasIntegration .gorgias-feedback-link {
  text-align: center;
  margin-top: 32px;
  padding: 16px;
  font-size: 14px;
}

/* Color picker box styles */
.BC-Page.BC-Page__GorgiasIntegration .colorPickerBox {
  position: relative;
}

.BC-Page.BC-Page__GorgiasIntegration .colorPickerBox .selectedColor {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  border: 1px solid #c4cdd5;
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 21; /* input have zIndex 20*/
}

.BC-Page.BC-Page__GorgiasIntegration .colorPickerBox .Polaris-TextField__Input {
  padding-left: 40px;
}

/* Form layout */
.BC-Page.BC-Page__GorgiasIntegration .gorgias-form {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  grid-gap: 16px;
}

.BC-Page.BC-Page__GorgiasIntegration .gorgias-form__row {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.BC-Page.BC-Page__GorgiasIntegration .gorgias-form__row:last-child {
  margin-bottom: 0;
}

.BC-Page.BC-Page__GorgiasIntegration .gorgias-form__field {
  flex: 1;
  min-width: 0;
}

.BC-Page.BC-Page__GorgiasIntegration .gorgias-style-settings__note .gorgias-style-settings__note-link {
  display: inline-flex;
  gap: 1px;
  align-items: center;
}

/* Action buttons */
.BC-Page.BC-Page__GorgiasIntegration .gorgias-actions {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
}`, "",{"version":3,"sources":["webpack://./src/styles/gorgias.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,qBAAqB;AACvB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,WAAW,EAAE,wBAAwB;AACvC;;AAEA;EACE,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX","sourcesContent":["/* Gorgias Integration Styles */\n.BC-Page.BC-Page__GorgiasIntegration .gorgias-container .gorgias-group-row {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.BC-Page.BC-Page__GorgiasIntegration .gorgias-container .gorgias-row {\n  display: flex;\n  gap: 20px;\n}\n\n.BC-Page.BC-Page__GorgiasIntegration .gorgias-container .gorgias-col-content {\n  width: 612px;\n  flex-shrink: 0;\n}\n\n.BC-Page.BC-Page__GorgiasIntegration .gorgias-container .Polaris-Card {\n  height: 100%;\n}\n\n.BC-Page.BC-Page__GorgiasIntegration .gorgias-container .Polaris-Card .card-inner {\n  padding: 16px;\n  height: 100%;\n}\n\n.BC-Page.BC-Page__GorgiasIntegration .gorgias-container .Polaris-Card .card-inner.card-inner--column {\n  display: flex;\n  flex-direction: column;\n}\n\n.BC-Page.BC-Page__GorgiasIntegration .gorgias-container .Polaris-Card .card-inner .BC-Switch-Status {\n  height: 16px;\n  width: 34px;\n  margin-right: 8px;\n  display: inline-flex;\n}\n\n.BC-Page.BC-Page__GorgiasIntegration .gorgias-container .Polaris-Card .card-inner .BC-Switch-Status__Bar {\n  width: 34px;\n  height: 16px;\n}\n\n.BC-Page.BC-Page__GorgiasIntegration .gorgias-container .Polaris-Card .card-inner .BC-Switch-Status__Dot {\n  width: 16px;\n  height: 16px;\n  transform: translateX(0);\n}\n\n.BC-Page.BC-Page__GorgiasIntegration .BC-Switch-Status input:checked+.BC-Switch-Status__Bar .BC-Switch-Status__Dot {\n  -webkit-transform: translateX(16px);\n  -ms-transform: translateX(16px);\n  transform: translateX(16px);\n}\n\n.BC-Page.BC-Page__GorgiasIntegration .BC-Page__Title--Help {\n  padding-left: 53px;\n}\n\n.BC-Page.BC-Page__GorgiasIntegration .gorgias-container .divider {\n  border: 1px solid #E1E3E5;\n  margin-bottom: 24px;\n}\n\n/* Style settings card */\n.BC-Page.BC-Page__GorgiasIntegration .gorgias-style-settings {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.BC-Page.BC-Page__GorgiasIntegration .gorgias-style-settings__preview-description {\n  margin-top: 2px;\n  margin-bottom: 16px;\n  color: #637381;\n  font-size: 14px;\n}\n\n.BC-Page.BC-Page__GorgiasIntegration .gorgias-style-settings__preview-box {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 70px;\n  padding: 16px 24px;\n  border: 1px dashed #c9cccf;\n  border-radius: 6px;\n}\n\n.BC-Page.BC-Page__GorgiasIntegration .gorgias-style-settings__container {\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* Button preview */\n.BC-Page.BC-Page__GorgiasIntegration .gorgias-button-preview__container {\n  display: inline-block;\n}\n\n/* Error message with icon */\n.BC-Page.BC-Page__GorgiasIntegration .gorgias-btn-text__container .gorgias-btn-text__label {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 4px;\n}\n\n.BC-Page.BC-Page__GorgiasIntegration .gorgias-btn-text__container .Polaris-Labelled__HelpText {\n  text-align: right;\n}\n\n.BC-Page.BC-Page__GorgiasIntegration .gorgias-btn-text__container .Polaris-InlineError {\n  margin-top: 0;\n}\n\n.BC-Page.BC-Page__GorgiasIntegration .gorgias-error-message {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.BC-Page.BC-Page__GorgiasIntegration .gorgias-error-message .Polaris-Icon {\n  width: 16px;\n  height: 16px;\n}\n\n/* Feedback link */\n.BC-Page.BC-Page__GorgiasIntegration .gorgias-feedback-link {\n  text-align: center;\n  margin-top: 32px;\n  padding: 16px;\n  font-size: 14px;\n}\n\n/* Color picker box styles */\n.BC-Page.BC-Page__GorgiasIntegration .colorPickerBox {\n  position: relative;\n}\n\n.BC-Page.BC-Page__GorgiasIntegration .colorPickerBox .selectedColor {\n  width: 24px;\n  height: 24px;\n  border-radius: 4px;\n  border: 1px solid #c4cdd5;\n  position: absolute;\n  left: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n  z-index: 21; /* input have zIndex 20*/\n}\n\n.BC-Page.BC-Page__GorgiasIntegration .colorPickerBox .Polaris-TextField__Input {\n  padding-left: 40px;\n}\n\n/* Form layout */\n.BC-Page.BC-Page__GorgiasIntegration .gorgias-form {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  grid-gap: 16px;\n}\n\n.BC-Page.BC-Page__GorgiasIntegration .gorgias-form__row {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.BC-Page.BC-Page__GorgiasIntegration .gorgias-form__row:last-child {\n  margin-bottom: 0;\n}\n\n.BC-Page.BC-Page__GorgiasIntegration .gorgias-form__field {\n  flex: 1;\n  min-width: 0;\n}\n\n.BC-Page.BC-Page__GorgiasIntegration .gorgias-style-settings__note .gorgias-style-settings__note-link {\n  display: inline-flex;\n  gap: 1px;\n  align-items: center;\n}\n\n/* Action buttons */\n.BC-Page.BC-Page__GorgiasIntegration .gorgias-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 16px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
